import {useCallback, useState} from "react";
import {DVIRForm, DVIRFormProps, DVIRFormValues} from "./DVIRForm";
import {SignatureModal} from "../../signature/SignatureModal/SignatureModal";

export type DVIRFormWithSignatureValues = {
  form: DVIRFormValues
  signature: { mimeType: string; dataUrl: string };
}

export type DVIRFormWithSignatureProps = Omit<DVIRFormProps, "onSubmit"> & {
  onSubmit?: (values: DVIRFormWithSignatureValues) => void
};

export const DVIRFormWithSignature = (props: DVIRFormWithSignatureProps) => {
  const {
    onSubmit,
    ...rest
  } = props;

  const [pendingForm, setPendingForm] = useState<DVIRFormValues | undefined>(undefined);
  const [signatureOpen, setSignatureOpen] = useState(false);

  const onFormSubmit = useCallback((values: DVIRFormValues) => {
    setPendingForm(values);
    setSignatureOpen(true);
  }, []);

  const onSignatureSubmit = useCallback((signature: { mimeType: string; dataUrl: string }) => {
    if (onSubmit) {
      if (!pendingForm) {
        return;
      }

      onSubmit({
        form: pendingForm,
        signature: signature
      });

      setSignatureOpen(false);
      setPendingForm(undefined);
    }
  }, [pendingForm, onSubmit])

  const onSignatureClose = useCallback(() => {
    setSignatureOpen(false);
    setPendingForm(undefined);
  }, [])

  return (
    <>
      <DVIRForm {...rest} onSubmit={onFormSubmit}/>
      <SignatureModal
        opened={signatureOpen}
        onClose={onSignatureClose}
        onSubmit={onSignatureSubmit}
      />
    </>
  );
};
